import Model from '@/models/Model'
import ChapterModel from '@/models/ChapterModel'

export default class TourModel extends Model {
  constructor (data, included = null) {
    super(data, included)
  }

  get chapters () {
    const cs = this.get('rel.chapters')
    return cs.map((c) => { return new ChapterModel(c, this._included) })
  }

  get coverVisual () {
    return this.get('rel.cover_visual.rel.field_image.attributes.url') || this.get('number')
  }

  get derivatives () {
    return this.get('rel.cover_visual.rel.field_image.links')
  }

  get tourType () {
    return this.get('rel.tour_type.attributes.name')
  }

  get title () {
    return this.get('attributes.title')
  }
}
